import React from 'react';
import cardPic from '../images/java.png'
import placholderSrc from '../images/javasmall.jpg'
import ProgressiveImg from '../components/ProgressiveImg';

export const JAVA = () => {

  const handleSelecting = (pageURL) => {

   window.location.href = "#" + pageURL; 
  }

  return (
  <div className='container m-0 mt-3'>
    <div className='row m-1'>
      <div  onClick={()=>{handleSelecting("/aufgaben")}}  className="card me-3"  style={{width:"18rem", cursor:'pointer'}}>
      <ProgressiveImg alt="..." src={cardPic} placeholderSrc={placholderSrc} 
        style={{ 
        width:"16rem", 
        cursor:'pointer',
        height:'222px'}} 
        /> 
      <div  className="card-body">
        <h5 className="card-title">Abenteuer1</h5>
        <p className="card-text">Erstelle HTML-ELEMENTE.</p>
        <a href="/#aufgaben" className="btn btn-primary">Los geht's!</a>
      </div>
     </div>
      <div  onClick={()=>{handleSelecting("/aufgabe2")}}  className="card"  style={{width:"18rem", cursor:'pointer'}}>
       <ProgressiveImg alt="..." src={cardPic} placeholderSrc={placholderSrc} 
        style={{ 
        width:"16rem", 
        cursor:'pointer',
        height:'222px'}} 
        /> 
        <div className="card-body">
          <h5 className="card-title">Abenteuer2</h5>
          <p className="card-text">Zentriere HTML-ELEMENTE.</p>
          <a href="/#aufgabe2" className="btn btn-primary">Los geht's!</a>
        </div>
      </div>
    </div>
    https://codemirror.net/
  </div>
  )
}
